import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={32}
    height={32}
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      transform="translate(7 5)"
    >
      <path d="M18 9c0 7-9 13-9 13S0 16 0 9a9 9 0 1 1 18 0h0Z" />
      <circle cx={9} cy={9} r={3} />
    </g>
  </svg>
);
export default SvgIcPin;
